var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"login "}},[_c('v-main',{staticClass:"login-panel",style:({ backgroundImage: `url(${_vm.backgroundUrl})` })},[_c('v-container',{attrs:{"fluid":""}},[_c('loading',{attrs:{"active":_vm.isLoading,"loader":_vm.loader}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }